module.exports = __webpack_public_path__ + "static/working-fc960c83ba29636d39725c8b807d2854.gif";